// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { LocaleResourceManager } from './manager/locale-resource.manager';

@Pipe({
  standalone: false,
  name: 'translateShortcut',
  pure: false,
})
export class TranslateShortcutPipe implements PipeTransform {

  constructor(private localeResourceManager: LocaleResourceManager) {
  }

  transform(value: string): unknown {
    const parts = value.split("+");
    for (let i = 0; i < parts.length; i++){
      const foundTranslation = this.localeResourceManager.findValueByKey("keyboard."+parts[i], null, true);
      if(foundTranslation) parts[i] = foundTranslation;
      parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

    }
    return parts.join("+");
  }

}
